import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePageTracking } from "../../hooks/usePageTracking";

export const ScrollToTop = (props:any) => {
    const location = useLocation();
    usePageTracking();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return <>{props.children}</>
};
